import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFile } from 'src/app/features/produits/models/products.models';

@Component({
  selector: 'app-prompt-to-order',
  templateUrl: './prompt-to-order.component.html',
  styleUrls: ['./prompt-to-order.component.scss']
})
export class PromptToOrderComponent {
  selectedFiles: IFile[] = [];
  unstructuredData: string = '';
  isDragging = false;

  constructor(
    private dialogRef: MatDialogRef<PromptToOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.processFiles(files);
    }
  }

  onFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    this.processFiles(input.files);
    // Allow selecting the same file(s) again
    if (input) input.value = '';
  }

  private processFiles(files: FileList): void {
    const filePromises = Array.from(files).map((file: File) => {
      return new Promise<IFile>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64Data = reader.result as string;
          resolve({
            data: base64Data.split(',')[1],
            filename: file.name,
            content_type: file.type,
          });
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(filePromises).then((newFiles: IFile[]) => {
      this.selectedFiles = [...this.selectedFiles, ...newFiles];
    }).catch((error) => {
      console.error('Error reading files:', error);
    });
  }

  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
  }

  save(): boolean | void {
    if(!this.unstructuredData && this.selectedFiles.length === 0) {
      return;
    }
    this.dialogRef.close({
      unstructuredData: this.unstructuredData,
      selectedFiles: this.selectedFiles
    });
  }

  close() {
    this.dialogRef.close();
  }

}
